import axiosClient from "../axios/axiosClient";

export function getPublicationTypes() {
  return axiosClient.get("/publication-types");
}

export function getPublicationType(publicationTypeId) {
  return axiosClient.get(`/publication-types/${publicationTypeId}`);
}

export function createPublicationType(data) {
  return axiosClient.post("/publication-types", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export const updatePublicationType = (publicationTypeId, data) => {
  return axiosClient.put(`/publication-types/${publicationTypeId}`, data);
};

export function deletePublicationType(publicationTypeId) {
  return axiosClient.delete(`/publication-types/${publicationTypeId}`);
}
